import { put, takeLatest } from "redux-saga/effects";
import { IFeedbackHistory, ITalk } from "src/common/types";
import { dateWithoutTime } from "src/helpers/date";
import { fetchMyFeedbacks } from "src/redux/actions";

export function* fetchFeedbackList() {
  try {
    const feedbackList = ((yield fetchMyFeedbacks()) as ITalk[]).sort(
      ({ talkCompletionDueDate: firstDueDate }, { talkCompletionDueDate: nextDueDate }) =>
        nextDueDate.getTime() - firstDueDate.getTime()
    );
    const currentDate = dateWithoutTime(new Date());

    const expiredTalks = feedbackList.filter(({ talkCompletionDueDate }) => {
      const maxCompletionDueDate = dateWithoutTime(new Date(talkCompletionDueDate));
      maxCompletionDueDate.setDate(maxCompletionDueDate.getDate() + 14);
      return maxCompletionDueDate < currentDate;
    });
    const active = feedbackList.filter(({ talkCompletionDueDate }) => {
      const maxCompletionDueDate = dateWithoutTime(new Date(talkCompletionDueDate));
      maxCompletionDueDate.setDate(maxCompletionDueDate.getDate() + 14);
      return maxCompletionDueDate >= currentDate;
    });
    const history = expiredTalks.reduce((acc, talk): IFeedbackHistory => {
      const { talkCompletionDueDate } = talk;
      const year = talkCompletionDueDate.getFullYear().toString();

      const existingYear = acc.find(([accYear]) => accYear === year);

      if (existingYear) {
        existingYear[1].push(talk);
      } else {
        acc.push([year, [talk]]);
      }
      return acc;
    }, [] as IFeedbackHistory);
    yield put({
      payload: {
        active,
        history
      },
      type: "GET_FEEDBACK_LIST_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({ type: "GET_FEEDBACK_LIST_REJECTED" });
  }
}

export default function* feedbackWatcher() {
  yield takeLatest("GET_FEEDBACK_LIST", fetchFeedbackList);
}
